import { Helmet } from "react-helmet-async";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import Pagebanner from "../../layout/Banner";
import ContactForm from "../../Components/HomeSections/ContactForm";

const ContactUS = () => {
  const brandGold = "#E3B66B";
  const darkGreen = "#0A1D1B";
  return (
    <>
      <Helmet>
        <title>Contact Us </title>
        <meta
          name="description"
          content="Get in touch with Advocate Saurav Dagar Chambers. Fill out our contact form to consult with our expert lawyers, ask questions, or request legal services."
        />
        <meta
          name="keywords"
          content="Contact Advocate Saurav Dagar, Legal Consultation, Law Firm Contact, Lawyer Inquiry, Legal Services Contact"
        />
        <noscript>
          Please enable JavaScript to view this website properly.
        </noscript>
      </Helmet>

      <Header />
      <Pagebanner title="Contact Us" />
      <ContactForm />

      {/* Map Section */}
      <section className={`bg-[${darkGreen}] py-12 px-6 md:px-12`}>
        <div
          className="max-w-7xl mx-auto rounded-lg overflow-hidden shadow-lg border-2"
          style={{ borderColor: brandGold }}
        >
          <iframe
            title="Advocate Saurav Dagar Chambers Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3500.545282263233!2d77.4438200752906!3d28.673330975642486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf19ccb87e065%3A0x7ad38bf5659528db!2sAdvocate%20Saurav%20Dagar%20%7C%20Civil%20%7C%20Criminal%20%7C%20Matrimonial%20%7C%20Accidental%20%7C%20Court%20Marriage%20Lawyer%20%7C%20Ghaziabad%2C%20U.P.!5e0!3m2!1sen!2sin!4v1777889179168!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ContactUS;

